import React from "react";
import { type FieldValues, useForm } from "react-hook-form";
import Button from "../../components/shared/button";
import { DatePicker } from "../../components/shared/inputs/datePicker";
import Input, {
  InputType,
  Password,
} from "../../components/shared/inputs/input";
import Select, { TreeSelect } from "../../components/shared/inputs/select";
import { SvgLoaderCircleSmall } from "../../components/svg";

import sampleImage from "../../styles/images/samples/sample_3.jpg";
// import Checkbox, { CheckboxType } from "components/shared/inputs/checkbox";
// import OptionBar from "components/shared/optionBar";

const InputComponents: React.FC = () => {
  const treeData = [
    {
      value: "parent 11",
      title: "parent 11",
      children: [
        {
          value: "parent 1-0",
          title: "parent 1-0",
          children: [
            {
              value: "leaf1",
              title: "leaf1",
            },
            {
              value: "leaf2",
              title: "leaf2",
            },
          ],
        },
        {
          value: "parent 1-1",
          title: "parent 1-1",
          children: [
            {
              value: "leaf3",
              title: <b data-color="secondary">leaf3</b>,
            },
          ],
        },
      ],
    },
  ];

  const { register, handleSubmit, reset, control } = useForm<FieldValues>({
    defaultValues: {
      asd: "",
      input1: "bbb",
      Notes: `In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.`,
    },
  });
  return (
    <view data-vertical="" data-adaptive="">
      <view
        data-space="40"
        data-gap="30"
        data-scroll=""
        data-size="medium"
        data-background="highlight"
      >
        <group
          data-border=""
          data-radius="15"
          data-contain=""
          data-background="main-background"
          data-shrink="no"
        >
          <group
            data-background="highlight"
            data-contain=""
            data-min-length="240"
            data-dark=""
          >
            <picture data-position="absolute" data-opacity="60">
              <img src={sampleImage} alt="" />
            </picture>
            <group
              //   data-radius="15"
              data-space="30"
              data-direction="column"
              data-align="start"
              data-gap="20"
            >
              <text
                data-weight="700"
                data-text-size="xxx-large"
                data-wrap="wrap"
              >
                Password Change
              </text>
              <text data-wrap="wrap" data-line="1.5">
                Your password is Case Sensitive. It should contain a minimum of
                8 characters and at least one each of Uppercase, Lowercase, and
                Special characters
              </text>
            </group>
          </group>

          <group data-space="40">
            <group data-direction="column" data-gap="10">
              <Password
                size="large"
                icon="key"
                placeholder="Old Password"
                dataLength="autofit"
                name="password_1"
              />

              <separator data-horizontal=""></separator>

              <Input
                size="large"
                // icon="key"
                placeholder="Create Password"
                dataLength="autofit"
                name="password_1"
              />
              <Input
                size="large"
                //    icon="key"
                placeholder="Repeat Password"
                dataLength="autofit"
                name="password_1"
              />
            </group>

            <space data-height="10"></space>
            <separator data-horizontal=""></separator>
            <space data-height="10"></space>

            <group data-gap="10">
              <Button large highlight data-shrink="no">
                <text>Cancel</text>
              </Button>
              <Button large secondary fit>
                <text>Update Password</text>
              </Button>
            </group>
          </group>
        </group>

        <group data-radius="10" data-index="2">
          <group data-direction="column" data-gap="5">
            <text
              data-weight="700"
              data-accent=""
              data-text-size="xxx-large"
              data-wrap="wrap"
            >
              Sample Form Layout
            </text>
            <text data-light="" data-wrap="wrap" data-line="1.5">
              Some info may be visible to other people using Our services. In
              publishing and graphic design, Lorem ipsum is a placeholder text
              commonly used to demonstrate the visual form of a document or a
              typeface without relying on meaningful content.
            </text>
          </group>

          <space></space>

          <group data-direction="column" data-gap="10">
            <Input
              size="large"
              labelPosition="left"
              dataLength="autofit"
              disabled
              label="Disabled Input"
              name="Disabled_input1"
              readOnly
              value="This is Disabled"
            />

            <group data-gap="10">
              <Input
                size="large"
                dataLength="autofit"
                labelPosition="left"
                label="Name"
                name="Disabled_input2"
                onChange={() => { }}
                value=" "
              />
              <Input
                size="large"
                dataLength="autofit"
                labelPosition="left"
                label="Last Name"
                name="Disabled_input3"
                onChange={() => { }}
                value=" "
              />
            </group>

            <separator data-horizontal=""></separator>

            <Input
              icon="phone"
              size="large"
              dataLength="autofit"
              labelPosition="left"
              //label="Last Name"

              name="Disabled_input4"
              onChange={() => { }}
              placeholder="Phone Number"
              // value="This is Disabled"
              button={
                <Button
                  large
                  icon="dialpad
"
                ></Button>
              }
            />
          </group>

          <space data-height="10"></space>
          <separator data-horizontal=""></separator>
          <space data-height="10"></space>

          <group data-type="grid" data-gap="10">
            <div className="button large primary">
              <text>Save Changes</text>
            </div>
            <div className="button large outline">
              <text>Cancel</text>
            </div>
          </group>
        </group>
      </view>
      <view data-size="small">
        <view data-space="20" data-scroll="">
          <group>
            <group data-gap="20">
              <Input
                //      size="large"
                dataLength="220"
                label="Number"
                control={control}
                name="numberik"
                placeholder="Select Number"
                type={InputType.Number}
                min={1}
                max={10}
              />
              <Select
                //    size="large"
                icon="person"
                label="Person"
                placeholder="Select a person"
                name="dropdown"
                dataLength="240"
                allowClear
                options={[
                  "Wolverine",
                  "Spider-Man",
                  "Thor",
                  "Iron Man",
                  "Hulk",
                  "Captain America",
                  "Daredevil",
                  "Punisher",
                  { value: 1, text: "Yondu Udonta" },
                  { value: "Star Lord" },
                ]}
              />

              <Select
                size="large"
                // disabled={true}
                icon="star"
                label="Hello"
                placeholder="Select a person"
                name="dropdown_multy"
                showSearch
                mode="multiple"
                dataLength="320"
                allowClear
                options={[
                  "Hulk",
                  "Captain America",
                  "Daredevil",
                  "Punisher",
                  { value: 1, text: "Yondu Udonta" },
                  { value: "Star Lord" },
                ]}
              />

              <DatePicker
                //  size="large"
                allowClear
                icon="home"
                name="dt"
                label="Birthday"
                placeholder="Select a Date"
              />

              <TreeSelect
                treeLine
                suffixIcon={null}
                // switcherIcon={
                //   <group data-name="tree-icon">
                //     <icon data-icon-size="24" data-icon-weight="600">
                //       expand_more
                //     </icon>
                //   </group>
                // }
                labelPosition="left"
                dataLength="260"
                name="treeSelect"
                label="TreeSelect"
                placeholder="Select a node"
                treeData={treeData}
              />
            </group>

            <space
              horizontal="" //NOSONAR
            ></space>
          </group>
        </view>
        <group data-space="20">
          <group data-type="grid" data-gap="10">
            <Button
              primary
              large
              text="Submit"
              onClick={handleSubmit((data: any) => console.log(data))}
            />
            <Button outline large text="Reset" onClick={() => reset()} />
          </group>
        </group>
      </view>
      <view data-space="20" data-container="" data-scroll="">
        <group direction="column" data-gap="20" data-align="start">
          <group direction="" data-gap="20">
            <div className="field" data-length="280">
              <div className="form_fields validationError">
                <div className="data_label">Search Here</div>
                <div className="field_cont">
                  <icon data-space="5">search</icon>
                  <input type="text" placeholder="Search" />
                  <i></i>
                </div>
                <errormessage>
                  <text data-wrap="wrap" className="errorMessage">
                    Name is required
                  </text>
                </errormessage>
              </div>
            </div>
            <space
              horizontal="" //NOSONAR
            ></space>

            <label //NOSONAR
              className="field"
              data-multi-element=""
            >
              <div className="form_fields">
                <div className="data_label">Search Here</div>
                <div className="field_cont">
                  <text data-margin="input">Label</text>
                  <separator data-vertical=""></separator>
                  <input type="text" placeholder="Placeholder" />
                  <separator data-vertical=""></separator>
                  <div className="button  micro">
                    <icon>navigate_next</icon>
                  </div>

                  <div className="button primary adaptive">
                    <icon>search</icon>
                    <text>Search</text>
                  </div>
                  <i></i>
                </div>
              </div>
            </label>

            <label //NOSONAR
              className="field"
              data-multi-element=""
            >
              <div className="form_fields">
                <div className="data_label">Search Here</div>
                <div className="field_cont">
                  <icon data-margin="input">search</icon>
                  <separator data-vertical=""></separator>
                  <input type="text" placeholder="Placeholder" />
                  <Button className="button primary" effect="material">
                    <text>Go</text>
                  </Button>
                  <i></i>
                </div>
              </div>
            </label>

            <label //NOSONAR
              className="field"
              data-multi-element=""
            >
              <div className="form_fields">
                <div className="data_label">Search Here</div>
                <div className="field_cont">
                  <icon data-margin="input" data-fill="" data-color="amber">
                    folder
                  </icon>
                  <separator data-vertical="" data-height="input"></separator>
                  <input type="text" placeholder="Placeholder" />
                  <separator data-vertical="" data-height="input"></separator>
                  <input type="text" placeholder="Placeholder" />
                  <Button secondary adaptive>
                    <icon>add</icon>
                    <text>Browse ...</text>
                  </Button>
                  <i></i>
                </div>
              </div>
            </label>

            <separator data-horizontal=""></separator>
          </group>

          <group>
            <Input
              icon={<SvgLoaderCircleSmall />}
              name="asd"
              dataLength="200"
              size="large"
              label="Large Input component"
            />
          </group>
          <group>
            <Input
              name="asd"
              labelPosition="left"
              icon="chair"
              size="large"
              label="Large Input component"
              button={
                <>
                  <separator data-vertical="" data-height="input"></separator>
                  <Button large icon="navigate_next"></Button>
                  <Button large primary text="Action"></Button>
                </>
              }
            />
          </group>
          <separator data-horizontal=""></separator>

          <group
            data-border=""
            data-radius="10"
            data-space="20"
            data-background="main-background"
          >
            <group data-direction="column" data-gap="10">
              <label //NOSONAR
                className="field"
                data-multi-element=""
                data-length="autofit"
              >
                <div className="form_fields">
                  <div className="data_label">Your Name</div>
                  <group data-gap="10">
                    <div className="field_cont" data-fit="1.5">
                      <input type="text" placeholder="Name" />
                      <i></i>
                    </div>
                    <div className="field_cont" data-fit="2.5">
                      <input type="text" placeholder="Surname" />
                      <i></i>
                    </div>
                  </group>
                </div>
              </label>

              <label //NOSONAR
                className="field"
                data-multi-element=""
                data-length="autofit"
              >
                <div className="form_fields">
                  <div className="data_label">
                    <text>Sample group</text>
                    <text data-weight="400" data-position="right">
                      Optional
                    </text>
                  </div>
                  <group data-gap="10">
                    <div className="field_cont" data-fit="1.5">
                      <input type="text" placeholder="Name" />
                      <i></i>
                    </div>
                    <div className="field_cont" data-fit="2.5">
                      <input type="text" placeholder="Surname" />
                      <i></i>
                    </div>
                    <div className="field_cont" data-fit="3">
                      <input type="text" placeholder="Surname" />
                      <i></i>
                    </div>
                  </group>
                </div>
              </label>
            </group>
          </group>

          <separator data-horizontal=""></separator>
          <group data-gap="20">
            <Input
              label="Input"
              dataLength="200"
              size="medium"
              aria-invalid="false"
              {...register("input1")}
            />

            <Input
              dataLength="280"
              disabled
              label="Sample Disabled Input Component"
              name="Disabled_input5"
              readOnly
              value="This is Disabled"
            />
          </group>

          <label //NOSONAR
            className="field"
            data-label="left"
            data-multi-element=""
            data-length="140"
          >
            <div className="form_fields">
              <div className="field_cont">
                <div className="button micro">
                  <icon>remove</icon>
                </div>
                <separator data-vertical=""></separator>
                <input
                  type="text"
                  data-text-align="center"
                  placeholder="0"
                  value={0}
                  readOnly
                />
                <separator data-vertical=""></separator>
                <div className="button micro">
                  <icon>add</icon>
                </div>
                <i></i>
              </div>
            </div>
          </label>

          <group
            data-direction="column"
            data-gap="10"
            data-border=""
            data-radius="10"
            data-space="10"
            data-width="auto"
          >
            <Input
              icon="mail"
              dataLength="240"
              placeholder="E-mail"
              name="mail_input"
            />

            <Password
              //   size="large"
              icon="key"
              placeholder="Password"
              dataLength="240"
              name="password_1"
            />
          </group>
          <group>
            <Input
              label="Code"
              placeholder="000 - 000 "
              name="input_with_button"
              button={<Button primary adaptive icon="barcode" text="Verify" />}
            />
          </group>

          <group data-gap="20">
            <Input
              disabled
              type={InputType.TextArea}
              dataLength="410"
              data-height="70"
              label="Disabled Textarea"
              //resize=""
              data-resize="none"
              placeholder="Notes"
              aria-invalid="false"
              {...register("Notes")}
              defaultValue="In publishing and graphic design, Lorem ipsum is a
                            placeholder text commonly used to demonstrate the
                            visual form of a document or a typeface without
                            relying on meaningful content. In publishing and
                            graphic design, Lorem ipsum is a placeholder text
                            commonly used to demonstrate the visual form of a
                            document or a typeface without relying on meaningful
                            content."
            />

            <Input
              dataLength="410"
              data-height="100"
              type={InputType.TextArea}
              name="textarea_error"
              label="Textarea"
              data-resize="y"
              //resize=""
              invalid
              error={{ message: "Error Message Goes Here" }}
              placeholder="Type or paste a note"
            />
          </group>
        </group>
      </view>

    </view>
  );
};
export default InputComponents;
